export const files_estruturas = {
  get_all: { method: "get", url: "api/files-estruturas" },
  show: { method: "get", url: "api/files-estruturas{/id}" },
  store: { method: "post", url: "api/files-estruturas" },
  update: { method: "put", url: "api/files-estruturas{/id}" },
  delete: { method: "delete", url: "api/files-estruturas{/id}" },
  to_select: { method: "get", url: "api/files-estruturas/to-select" },
};

export const files_categorias = {
  /*
  get_all: { method: "get", url: "api/files-categorias" },
  show: { method: "get", url: "api/files-categorias{/id}" },
  store: { method: "post", url: "api/files-categorias" },
  update: { method: "put", url: "api/files-categorias{/id}" },
  delete: { method: "delete", url: "api/files-categorias{/id}" },
  */
  to_select: { method: "get", url: "api/files-categorias/to-select" },
};

export const files = {
  get_all: { method: "get", url: "api/files" },
  show: { method: "get", url: "api/files{/id}" },
  store: { method: "post", url: "api/files" },
  update: { method: "post", url: "api/files{/id}" },
  delete: { method: "delete", url: "api/files{/id}" },
  in_storage: { method: "get", url: "api/files/in-storage" },
  view: { method: "get", url: "api/files/view{/path}" },
};

export default files;
